import { SECURE_SPORTS_API_BASE } from "./config";
const LOCAL_PREVIEW_BUILD = process.env.REACT_APP_PWG_PRODUCTION_RELEASE !== "1";

// The Match Intelligence pilot is intentionally served by the local Flask
// artifact adapter during localhost review.  Other secure-sports clients keep
// their existing configuration, and non-local hosts continue to use the
// configured production API base.
const localMatchIntelligenceBase = () => {
  if (!LOCAL_PREVIEW_BUILD) return "";
  const host = typeof window === "undefined" ? "" : String(window.location?.hostname || "");
  return /^(localhost|127\.0\.0\.1)$/.test(host) ? `http://${host}:5051/api` : "";
};

const normalizeBase = String(localMatchIntelligenceBase() || SECURE_SPORTS_API_BASE || "").replace(/\/$/, "");

async function read(path) {
  const response = await fetch(`${normalizeBase}${path}`, {
    headers: { Accept: "application/json" },
    cache: "no-store",
  });
  if (response.status === 404) return null;
  const payload = await response.json().catch(() => null);
  if (!response.ok) throw new Error(payload?.error || "Match Intelligence is temporarily unavailable.");
  return payload;
}

export const loadSoccerMatches = () => read("/sports/soccer/matches");
export const loadSoccerMatchDetail = (matchId) =>
  matchId ? read(`/sports/soccer/matches/${encodeURIComponent(matchId)}`) : Promise.resolve(null);
